import React, {useContext, useEffect, useState} from 'react'
import CarOverview from 'app/React/Components/CarOverview/CarOverview'
import ColorCode from 'app/React/Components/CarOverview/ColorCode'
import SubmitButton from 'app/React/Components/Form/SubmitButton'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function DealerCheckoutOverview() {
  const {
    car,
    colorImage,
    currentEngineTransmission,
    currentVariant,
    dealerNumberOptions,
    order,
    strings,
    setOrder,
    setCurrentDealerColorTotalCount
  } = useContext(ConfiguratorContext)

  const dealerStrings = strings.payment_form?.dealer_checkout ?? {}
  const dealerColors = order.configuration?.dealer_colors ?? []
  const dealerOrderType = order.dealer_order_type ?? null
  const dealerNumber = order.dealer_number ?? null
  const extraEquipments = order.configuration?.extra_equipments ?? {}
  const paymentStrings = strings.payment_form ?? {}

  const informationList = () => {
    let list = []

    if (dealerOrderType === 'customer_car') {
      list.push({
        title: dealerStrings.color + ':',
        content: <ColorCode text={colorImage?.title} imageUrl={colorImage?.image_url} borderHex={'#E0E0E0'}/>
      })
    }

    const currentDealer = dealerNumberOptions.find(dealer => dealer.value === dealerNumber)
    const extraEquipmentsList = []
    Object.values(extraEquipments).forEach(ids => {
      ids.map(id => {
        extraEquipmentsList.push(currentVariant?.equipment_variants.find(extraEquipment => String(extraEquipment.id) === id)?.name)
      })
    })

    extraEquipmentsList.sort()

    const dealerContent = dealerNumberOptions.length === 0 ? dealerStrings.no_dealer_available : currentDealer?.label ?? dealerStrings.pick_dealer
    let engineContent = currentEngineTransmission?.engine?.name + ' '
    engineContent += currentEngineTransmission?.formatted_phev_total_horsepower ?? currentEngineTransmission?.formatted_horsepower

    list.push({ title: dealerStrings.dealer + ':', content: dealerContent })
    list.push({ title: dealerStrings.equipment_variant + ':', content: currentVariant?.name })
    list.push({ title: dealerStrings.sale_status + ':', content: paymentStrings.dealer_order_type[dealerOrderType] })
    list.push({ title: dealerStrings.engine + ':', content: engineContent })
    list.push({ title: dealerStrings.transmission + ':', content: currentEngineTransmission?.transmission?.name })
    list.push({ title: dealerStrings.extraEquipments + ':', content: extraEquipmentsList.join('<br />') })

    return list
  }

  useEffect(() => {
    if (['customer_car', 'company_car'].includes(dealerOrderType)) {
      order.configuration.dealer_colors = []
      setOrder({ ...order })
      setCurrentDealerColorTotalCount(1)
      return
    }

    if (dealerColors.length > 0) {
      return
    }

    const color = order.configuration.color

    let colors = currentVariant.mappedColors
      .filter((mappedColor) => mappedColor.required_engine === undefined ||
        mappedColor.required_engine?.length === 0 ||
        mappedColor.required_engine?.includes(currentEngineTransmission.engine_id)
      )
      .sort((a, b) => a.title.localeCompare(b.title))
      .map(mappedColor => {
        return {
          id: mappedColor.id,
          title: mappedColor.title,
          imageUrl: mappedColor.image_url,
          borderHex: '#E0E0E0',
          backgroundColor: mappedColor.color_hex,
          value: color.id === mappedColor.id ? 1 : 0,
          minimumValue: color.id === mappedColor.id ? 1 : 0
        }
      })

    setCurrentDealerColorTotalCount(1)

    order.configuration.dealer_colors = colors
    setOrder({ ...order })
  }, [dealerOrderType])

  return (
    <div className='config-overview'>
      <CarOverview
        marginTop
        name={car.title}
        image={colorImage?.color_image_url}
        list={informationList()}
        colorsTitle={dealerOrderType !== 'customer_car' ? dealerStrings.colors : null}
      />

      <SubmitButton
        text={car.title}
        buttonText={dealerStrings.order_now}
        prefix={dealerStrings.configurating}
        isPaymentButton
      />
    </div>
  )
}
